import { unref } from '@vue/composition-api';
import { useMutation, useQueryClient } from 'vue-query';
import { addCart } from '@/api/ggoods/detail';

import AlarmMsg from '@/utils/alarmMsg';

export default function useAddCartAPI({ mutationKey, onError, onMutate, onSettled, onSuccess, useErrorBoundary } = {}) {
	const queryClient = useQueryClient();

	return useMutation(
		async data => {
			const { goodsNo, categorySeq } = data;
			const goodsNumbers = (() => {
				const origin = unref(goodsNo);
				if (Array.isArray(origin)) return origin.map(String);
				if (!origin) return [];
				return [String(origin)];
			})();

			if (!goodsNumbers.length) throw new Error('goodsNo is empty');

			const param = {
				goodsNo: goodsNumbers,
			};
			if (categorySeq) param.categorySeq = unref(categorySeq);

			const response = await addCart(param);

			const { code, message, result } = response;

			if (code === 'ERR0200') {
				AlarmMsg.showMsg('장바구니에 담을 수 있는 상품 수량은 최대 20개입니다.');
				throw new Error(`${code}: ${message}`);
			}

			if (code === 'ERR0220') {
				AlarmMsg.showMsg('이미 장바구니에 담은 상품입니다.');
				throw new Error(`${code}: ${message}`);
			}

			if (code !== 'SUC0000') {
				AlarmMsg.getMsg(response);
				throw new Error(`${code}: ${message}`);
			}

			// 판매중지된 상품 존재시
			if (code === 'SUC0000') {
				if (result?.susGoodsYn === 'Y') {
					await AlarmMsg.showMsg(result?.susGoodsNm + '은(는) 더 이상 구매하실 수 없는 상품입니다.');
					return;
				}

				if (result.newJoinBuyPossible && result.newJoinBuyPossible === 'N') {
					AlarmMsg.showMsg('신규가입자 대상 이벤트 상품입니다. 고객님은 구매가 불가능합니다.');
					throw new Error('신규가입자 대상 이벤트 상품입니다. 고객님은 구매가 불가능합니다.');
				}
			}

			return result;
		},
		{
			mutationKey,
			onError,
			onMutate,
			onSettled,
			onSuccess: (...args) => {
				queryClient.invalidateQueries('cart');
				onSuccess?.(...args);
			},
			useErrorBoundary,
		}
	);
}
